import { Link } from "react-router-dom";
import { FaFacebookF, FaTiktok, FaYoutube, FaLinkedinIn } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-[#082f49] text-white pt-10 pb-6 mt-12">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-5 gap-8">
        {/* Logo & mô tả */}
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center gap-2">
            <div className="text-2xl font-serif font-bold tracking-widest uppercase">
              <span className="text-[#c9a063]">Mỹ Diệp</span> Property
            </div>
          </Link>
          <p className="text-sm leading-relaxed mb-4">
            Mỹ Diệp Property – Đơn vị tư vấn & phân phối bất động sản uy tín,
            mang đến giải pháp đầu tư minh bạch, hiệu quả và tiêu chuẩn dịch vụ cao cấp.
          </p>
          <div className="flex space-x-4 text-xl">
            <FaFacebookF className="hover:text-blue-400 cursor-pointer" />
            <FaTiktok className="hover:text-blue-400 cursor-pointer" />
            <FaYoutube className="hover:text-blue-400 cursor-pointer" />
            <FaLinkedinIn className="hover:text-blue-400 cursor-pointer" />
          </div>
        </div>

        {/* Đăng ký nhận tin */}
        <div className="md:col-span-3">
          <h3 className="font-semibold mb-2 text-lg">Đăng ký nhận bảng giá & ưu đãi</h3>
          <p className="text-sm mb-3">
            Nhận thông tin mở bán, bảng giá ưu đãi và chính sách mới nhất từ chúng tôi.
          </p>
          <form className="flex max-w-md">
            <input
              type="email"
              placeholder="Nhập email của bạn"
              className="flex-1 px-4 py-2 rounded-l-md text-black outline-none"
            />
            <button
              type="submit"
              className="bg-orange-500 hover:bg-orange-600 px-4 py-2 rounded-r-md font-medium"
            >
              Gửi
            </button>
          </form>
        </div>
      </div>

      {/* Menu Footer */}
      <div className="max-w-7xl mx-auto px-4 mt-10 grid grid-cols-2 md:grid-cols-4 gap-6 text-sm">
        <div>
          <h4 className="font-semibold mb-2">Dự án nổi bật</h4>
          <ul className="space-y-1">
            <li>Green Paradise</li>
            <li>The Global City</li>
            <li>Eco Retreat</li>
            <li>Aqua City</li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold mb-2">Khám phá</h4>
          <ul className="space-y-1">
            <li>Mua căn hộ</li>
            <li>Mua nhà phố & biệt thự</li>
            <li>Thuê căn hộ</li>
            <li>Ưu đãi & chính sách</li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold mb-2">Hỗ trợ</h4>
          <ul className="space-y-1">
            <li>Hướng dẫn thanh toán</li>
            <li>Chính sách vay vốn</li>
            <li>Câu hỏi thường gặp</li>
            <li>Liên hệ tư vấn</li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold mb-2">Về chúng tôi</h4>
          <ul className="space-y-1">
            <li>Giới thiệu Mỹ Diệp Property</li>
            <li>Tin tức & sự kiện</li>
            <li>Chính sách bảo mật</li>
            <li>Điều khoản sử dụng</li>
          </ul>
        </div>
      </div>

      {/* Địa chỉ & bản quyền */}
      <div className="mt-8 border-t border-gray-600 pt-4 text-center text-xs text-gray-300 px-4">
        Mỹ Diệp Property – Đơn vị tư vấn và phân phối bất động sản cao cấp. Hotline: 0902 487 996.
        Địa chỉ: mydiepproperties@gmail.com
        <br />
        © {new Date().getFullYear()} Mỹ Diệp Property. All rights reserved.
      </div>
    </footer>
  );
}
